export const EARN_POINTS_LABELS = 'account.earnExtraPoints';
export const ACCOUNT_COMMON = 'account.common';

export const lblEarnExtraPointsImageAlt = 'lbl_earnExtraPoints_imageAlt';
export const lblEarnExtraPointsViewPointsHistory = 'lbl_earnExtraPoints_view_points_history';
export const lblExtraExtraPointsMorePoints = 'lbl_extraExtraPoints_more_points';

export const lblEarnExtraPointsYouEarned = 'lbl_earnExtraPoints_you_earned';
export const lblEarnExtraPointsPlaceRewards = 'lbl_earnExtraPoints_place_rewards';
export const lblEarnExtraPointsYouAreEarning = 'lbl_earnExtraPoints_youAreEarning';
export const lblEarnExtraPointsLearnMore = 'lbl_earnExtraPoints_learnMore';

export const lblCommonExtraPointsHeading = 'lbl_common_extraPointsHeading';
export const lblCommonCheckHere = 'lbl_common_check_here';
export const lblCommonExtraPointsTermsConditions = 'lbl_common_extra_points_terms_conditions';

const EarnExtraPointsLabels = {
  account: {
    common: {
      [lblExtraExtraPointsMorePoints]: 'Earn even more points by activating these offers!',
      [lblCommonExtraPointsHeading]: 'EARN EXTRA POINTS',
      [lblCommonCheckHere]: '*Click Here ',
      [lblCommonExtraPointsTermsConditions]: 'for Earn Extra Points Terms & Conditions',
    },
    earnExtraPoints: {
      [lblEarnExtraPointsImageAlt]: 'info icon',
      [lblEarnExtraPointsViewPointsHistory]: 'View Points History',
      [lblEarnExtraPointsYouEarned]: 'You earned',
      [lblEarnExtraPointsPlaceRewards]: 'My Place Rewards Points!',
      [lblEarnExtraPointsYouAreEarning]: 'Earn Points Even Faster!',

      [lblEarnExtraPointsLearnMore]: ' Learn more',
    },
  },
};
export default EarnExtraPointsLabels;
